<template>
    <section class="dashboardBloc col-lg-6 col-md-6 col-xs-12">
        <div class="dashboard-container full">
            <header class="flexContainer jc-sb">
                <div class="blockTitle">
                    <h2 class="jc-sb full"><slot name="title"></slot></h2>
                </div>
            </header>
            <section class="dashboardWrapper flexContainer mobileNot fw-w tabletNot"><slot name="content-desktop" /></section>
            <section class="mobileOnly"><slot name="content-mobile" /></section>
            <footer v-if="!noFooter" class="flexContainer jc-fe">
                <div class="blockAction"><slot name="footer"></slot></div>
            </footer>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        noFooter: Boolean,
        default: false
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/themes.scss";
.dashboardBloc {
    padding-top: 0;
    margin-top: 10px;
    .dashboard-container {
        @extend %primary-bloc;
    }
    header {
        padding: 0px;
        margin-bottom: 10px;
        .blockTitle {
            width: 100%;
            text-transform: uppercase;
            h2 {
                @extend %third-background;
                @extend %second-border-color;
                @extend %primary-text;
                padding: 8px;
                font-size: 25px;
                width: 100%;
                margin: 0;
                margin-bottom: 10px;
                font-family: Oswald;
                letter-spacing: 1px;
                font-weight: normal;
            }
            .subtitle {
                padding: 10px 20px;
            }
        }
    }
    footer {
        padding-top: 10px;
        padding-bottom: 5px;
        .blockAction {
            width: 100%;
            border-top: 1px solid #e2e2e2;
            font-size: 1.4rem;
            text-align: right;
            padding-top: 15px;
        }
    }
    > * {
        padding: 10px 20px;
    }
}
</style>



// WEBPACK FOOTER //
// BaseWidget.vue?2b2cca7a